if (!customElements.get('pickup-availability')) {
  customElements.define(
    'pickup-availability',
    class PickupAvailability extends HTMLElement {
      constructor() {
        super();

        if (!this.hasAttribute('available')) return;

        this.errorHtml = this.querySelector('template').content.firstElementChild.cloneNode(true);
        this.onClickRefreshList = this.onClickRefreshList.bind(this);
        this.fetchAvailability(this.dataset.variantId);
      }

      normalizeLocationName(value) {
        if (value == null) return '';
        return String(value)
          .trim()
          .replace(/\s+/g, ' ')
          .toLowerCase();
      }

      getAllowedLocationsSet() {
        const raw = this.dataset.allowedLocations;
        if (!raw) return null;

        try {
          const parsed = JSON.parse(raw);
          if (!Array.isArray(parsed)) return null;

          const normalized = parsed
            .map((v) => this.normalizeLocationName(v))
            .filter((v) => v.length > 0);

          // If an allowlist is provided but ends up empty (e.g. all locations disabled),
          // treat it as "show nothing" (empty set), not "show everything".
          if (normalized.length === 0) return new Set();
          return new Set(normalized);
        } catch (e) {
          return null;
        }
      }

      fetchAvailability(variantId) {
        let rootUrl = this.dataset.rootUrl;
        if (!rootUrl.endsWith('/')) {
          rootUrl = rootUrl + '/';
        }
        const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=pickup-availability`;

        fetch(variantSectionUrl)
          .then((response) => response.text())
          .then((text) => {
            const sectionInnerHTML = new DOMParser()
              .parseFromString(text, 'text/html')
              .querySelector('.shopify-section');
            this.renderPreview(sectionInnerHTML);
          })
          .catch((e) => {
            const button = this.querySelector('button');
            if (button) button.removeEventListener('click', this.onClickRefreshList);
            this.renderError();
          });
      }

      onClickRefreshList(evt) {
        this.fetchAvailability(this.dataset.variantId);
      }

      update(variant) {
        if (variant?.available) {
          this.fetchAvailability(variant.id);
        } else {
          this.removeAttribute('available');
          this.innerHTML = '';
        }
      }

      renderError() {
        this.innerHTML = '';
        this.appendChild(this.errorHtml);

        this.querySelector('button').addEventListener('click', this.onClickRefreshList);
      }

      renderPreview(sectionInnerHTML) {
        const drawer = document.querySelector('pickup-availability-drawer');
        if (drawer) drawer.remove();
        if (!sectionInnerHTML.querySelector('pickup-availability-preview')) {
          this.innerHTML = '';
          this.removeAttribute('available');
          return;
        }

        this.innerHTML = sectionInnerHTML.querySelector('pickup-availability-preview').outerHTML;
        this.setAttribute('available', '');

        document.body.appendChild(sectionInnerHTML.querySelector('pickup-availability-drawer'));

        const allowedLocations = this.getAllowedLocationsSet();
        if (allowedLocations !== null) {
          const allItems = document.querySelectorAll('.pickup-availability-list__item');
          allItems.forEach((item) => {
            const name = this.normalizeLocationName(item.getAttribute('data-location-name'));
            if (!allowedLocations.has(name)) item.remove();
          });
        }

        const items = document.querySelectorAll('.pickup-availability-list__item');
        // If filtering is active and nothing matches, hide the pickup availability UI entirely.
        if (allowedLocations !== null && items.length === 0) {
          const drawerEl = document.querySelector('pickup-availability-drawer');
          if (drawerEl) drawerEl.remove();
          this.innerHTML = '';
          this.removeAttribute('available');
          return;
        }
        let allUnavailable = false;
        const preorder_item = document.querySelector('.jsc-preorder-item');
        let preorder = false;

        if (items.length > 0) {
          allUnavailable = Array.from(items).every(
            (item) => item.getAttribute('data-location-available') === 'false'
          );
        }
        if (preorder_item) {
          preorder = true;
        }

        console.log('Are all stores unavailable?', allUnavailable);
        if (allUnavailable == true) {
          const locationEl = document.querySelector('.pickup-availability-info__location');
          if (locationEl) {
            locationEl.textContent = 'Pickup currently available at these stores.';
          }
          const viewStore = document.querySelector('.pickup-availability-info__pickup-help');
          if (viewStore) {
            viewStore.textContent = 'View stores lists.';
          }
        }

        if (preorder == true ) {
          const locationEl = document.querySelector('.pickup-availability-info__location');
          if (locationEl) {
            locationEl.textContent = 'Pickup currently unavailable at all stores.';
          }
          const viewStore = document.querySelector('.pickup-availability-info__pickup-help');
          if (viewStore) {
            viewStore.style.display = 'none';
          }
          const pickupButton = document.querySelector('.pickup-availability-button');
          if (pickupButton) {
            pickupButton.style.display = 'none';
          }
          const pickupTime = document.querySelector('.pickup-availability-info__pickup-time');
          if (pickupTime) {
            pickupTime.style.display = 'none';
          }
        }
      }
    }
  );
}

if (!customElements.get('pickup-availability-drawer')) {
  customElements.define(
    'pickup-availability-drawer',
    class PickupAvailabilityDrawer extends BasicModal {
      constructor() {
        super();
      }
    }
  );
}
